let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kCPaP")).then(() => parcelRequire('4aHpv'));